// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TT33","rootNoMargin":"styles_rootNoMargin__2gfLp"};